{
  "familyId": "REK-CIJF-PLUS",
  "questions": [
    {
      "id": "REK-CIJF-PLUS-001",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 347 + 285",
      "options": [],
      "correctAnswer": "632",
      "data": {
        "operand1": 347,
        "operand2": 285,
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — stap voor stap",
            "content": "Zet de getallen onder elkaar. Begin rechts:\n• Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1\n• Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1\n• Honderdtallen: 3 + 2 + 1 = 6\nAntwoord: 632",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_onthouden",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.64,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet het onthoud-cijfer mee te tellen in de volgende kolom" }
        ]
      },
      "feedback": {
        "explanationText": "Zet 347 en 285 onder elkaar en begin rechts bij de eenheden. Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1. Tientallen: 4 + 8 + 1 (onthouden) = 13 → schrijf 3, onthoud 1. Honderdtallen: 3 + 2 + 1 = 6. Antwoord: 632.",
        "solutionSteps": [
          "Zet onder elkaar: 347 + 285",
          "Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1",
          "Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1",
          "Honderdtallen: 3 + 2 + 1 = 6",
          "Antwoord: 632"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-002",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 1.456 + 2.378",
      "options": [],
      "correctAnswer": "3834",
      "data": {
        "operand1": 1456,
        "operand2": 2378,
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — 4 cijfers",
            "content": "Zet onder elkaar en begin rechts:\n• E: 6 + 8 = 14 → schrijf 4, onthoud 1\n• T: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1\n• H: 4 + 3 + 1 = 8\n• D: 1 + 2 = 3\nAntwoord: 3.834",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_viercijferig",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.66,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet het onthoud-cijfer in een volgende kolom" },
          { "id": "rek.kolommen-verkeerd-uitgelijnd", "label": "Schrijft cijfers in de verkeerde kolom bij vier-cijferige som" }
        ]
      },
      "feedback": {
        "explanationText": "Zet 1.456 en 2.378 onder elkaar. Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1. Tientallen: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1. Honderdtallen: 4 + 3 + 1 = 8. Duizendtallen: 1 + 2 = 3. Antwoord: 3.834.",
        "solutionSteps": [
          "Zet onder elkaar: 1.456 + 2.378",
          "Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1",
          "Honderdtallen: 4 + 3 + 1 = 8",
          "Duizendtallen: 1 + 2 = 3",
          "Antwoord: 3.834"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-003",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "fill_in",
      "question": "Een school bestelt 468 schriften en later nog 357 schriften. Hoeveel schriften zijn er in totaal besteld?",
      "options": [],
      "correctAnswer": "825",
      "data": {
        "acceptedAnswers": ["825"],
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "column",
          "showWhen": "wrong",
          "data": {
            "operand1": 468,
            "operand2": 357,
            "operation": "+"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met context",
            "content": "Je moet optellen: 468 + 357. Begin rechts:\n• E: 8 + 7 = 15 → schrijf 5, onthoud 1\n• T: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1\n• H: 4 + 3 + 1 = 8\nAntwoord: 825 schriften",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet het onthoud-cijfer bij 468 + 357" },
          { "id": "rek.context-verkeerde-bewerking", "label": "Trekt af i.p.v. op te tellen bij 'later nog'" }
        ]
      },
      "feedback": {
        "explanationText": "De school bestelt 468 + 357 schriften. Eenheden: 8 + 7 = 15 → schrijf 5, onthoud 1. Tientallen: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1. Honderdtallen: 4 + 3 + 1 = 8. Totaal: 825 schriften.",
        "solutionSteps": [
          "Herken de bewerking: 468 + 357",
          "Eenheden: 8 + 7 = 15 → schrijf 5, onthoud 1",
          "Tientallen: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1",
          "Honderdtallen: 4 + 3 + 1 = 8",
          "Antwoord: 825 schriften"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-004",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "fill_in",
      "question": "Bij cijferend optellen van 576 + 248: welk cijfer schrijf je op bij de tientallen?",
      "options": [],
      "correctAnswer": "2",
      "data": {
        "acceptedAnswers": ["2"],
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap — tientallen",
            "content": "Eerst de eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1. Dan de tientallen: 7 + 4 + 1 (onthouden) = 12 → schrijf 2, onthoud 1. Je schrijft dus 2 bij de tientallen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_tussenresultaat",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.62,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet de onthouden 1 bij de tientallen (schrijft 1 i.p.v. 2)" }
        ]
      },
      "feedback": {
        "explanationText": "Bij de tientallen reken je: 7 + 4 = 11, plus 1 onthouden van de eenheden = 12. Je schrijft 2 op en onthoudt 1 voor de honderdtallen. Het volledige antwoord: 576 + 248 = 824.",
        "solutionSteps": [
          "Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 7 + 4 + 1 = 12 → schrijf 2, onthoud 1",
          "Honderdtallen: 5 + 2 + 1 = 8",
          "Antwoord: 824"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-005",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 695 + 189",
      "options": [],
      "correctAnswer": "884",
      "data": {
        "operand1": 695,
        "operand2": 189,
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbel onthouden",
            "content": "Soms moet je twee keer onthouden:\n• E: 5 + 9 = 14 → schrijf 4, onthoud 1\n• T: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1\n• H: 6 + 1 + 1 = 8\nAntwoord: 884",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_dubbel_onthouden",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.65,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet één van de twee onthoud-cijfers mee te tellen" },
          { "id": "rek.verkeerd-getal-onthouden", "label": "Telt verkeerd onthoud-cijfer op (bijv. 2 i.p.v. 1)" }
        ]
      },
      "feedback": {
        "explanationText": "695 + 189: Eenheden: 5 + 9 = 14 → schrijf 4, onthoud 1. Tientallen: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1. Honderdtallen: 6 + 1 + 1 = 8. Antwoord: 884. Let op: je moet hier twee keer onthouden!",
        "solutionSteps": [
          "Eenheden: 5 + 9 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1",
          "Honderdtallen: 6 + 1 + 1 = 8",
          "Antwoord: 884"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-006",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 3.749 + 1.586",
      "options": [],
      "correctAnswer": "5335",
      "data": {
        "operand1": 3749,
        "operand2": 1586,
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — 4 cijfers met veel onthouden",
            "content": "Zet onder elkaar en begin rechts:\n• E: 9 + 6 = 15 → schrijf 5, onthoud 1\n• T: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1\n• H: 7 + 5 + 1 = 13 → schrijf 3, onthoud 1\n• D: 3 + 1 + 1 = 5\nAntwoord: 5.335",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_viercijferig_veel_onthouden",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet één van de drie onthoud-cijfers bij vier-cijferige som" },
          { "id": "rek.verkeerd-getal-onthouden", "label": "Onthoudt verkeerde waarde bij meervoudig onthouden" }
        ]
      },
      "feedback": {
        "explanationText": "3.749 + 1.586: Begin rechts. Eenheden: 9 + 6 = 15 → schrijf 5, onthoud 1. Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1. Honderdtallen: 7 + 5 + 1 = 13 → schrijf 3, onthoud 1. Duizendtallen: 3 + 1 + 1 = 5. Antwoord: 5.335. Let op: je moet hier drie keer onthouden!",
        "solutionSteps": [
          "Eenheden: 9 + 6 = 15 → schrijf 5, onthoud 1",
          "Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1",
          "Honderdtallen: 7 + 5 + 1 = 13 → schrijf 3, onthoud 1",
          "Duizendtallen: 3 + 1 + 1 = 5",
          "Antwoord: 5.335"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-007",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 4.997 + 2.468",
      "options": [],
      "correctAnswer": "7465",
      "data": {
        "operand1": 4997,
        "operand2": 2468,
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met grote getallen",
            "content": "Zet onder elkaar en begin rechts:\n• E: 7 + 8 = 15 → schrijf 5, onthoud 1\n• T: 9 + 6 + 1 = 16 → schrijf 6, onthoud 1\n• H: 9 + 4 + 1 = 14 → schrijf 4, onthoud 1\n• D: 4 + 2 + 1 = 7\nAntwoord: 7.465",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_viercijferig_negens",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet onthoud bij kolommen met negens (9 + cijfer ≥ 10)" },
          { "id": "rek.verkeerd-getal-onthouden", "label": "Onthoudt verkeerd cijfer bij optelling met negens" }
        ]
      },
      "feedback": {
        "explanationText": "4.997 + 2.468: Eenheden: 7 + 8 = 15 → schrijf 5, onthoud 1. Tientallen: 9 + 6 + 1 = 16 → schrijf 6, onthoud 1. Honderdtallen: 9 + 4 + 1 = 14 → schrijf 4, onthoud 1. Duizendtallen: 4 + 2 + 1 = 7. Antwoord: 7.465.",
        "solutionSteps": [
          "Eenheden: 7 + 8 = 15 → schrijf 5, onthoud 1",
          "Tientallen: 9 + 6 + 1 = 16 → schrijf 6, onthoud 1",
          "Honderdtallen: 9 + 4 + 1 = 14 → schrijf 4, onthoud 1",
          "Duizendtallen: 4 + 2 + 1 = 7",
          "Antwoord: 7.465"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-008",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "fill_in",
      "question": "Een dierentuin heeft 2.845 bezoekers op zaterdag en 1.978 bezoekers op zondag. Hoeveel bezoekers waren er in het weekend?",
      "options": [],
      "correctAnswer": "4823",
      "data": {
        "acceptedAnswers": ["4823", "4.823"],
        "operation": "+"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "column",
          "showWhen": "wrong",
          "data": {
            "operand1": 2845,
            "operand2": 1978,
            "operation": "+"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met context — 4 cijfers",
            "content": "Je moet optellen: 2.845 + 1.978. Begin rechts:\n• E: 5 + 8 = 13 → schrijf 3, onthoud 1\n• T: 4 + 7 + 1 = 12 → schrijf 2, onthoud 1\n• H: 8 + 9 + 1 = 18 → schrijf 8, onthoud 1\n• D: 2 + 1 + 1 = 4\nAntwoord: 4.823 bezoekers",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_context_viercijferig",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.66,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet één van de drie onthoud-cijfers bij 2.845 + 1.978" }
        ]
      },
      "feedback": {
        "explanationText": "2.845 + 1.978: Eenheden: 5 + 8 = 13 → schrijf 3, onthoud 1. Tientallen: 4 + 7 + 1 = 12 → schrijf 2, onthoud 1. Honderdtallen: 8 + 9 + 1 = 18 → schrijf 8, onthoud 1. Duizendtallen: 2 + 1 + 1 = 4. Totaal: 4.823 bezoekers in het weekend.",
        "solutionSteps": [
          "Herken de bewerking: 2.845 + 1.978",
          "Eenheden: 5 + 8 = 13 → schrijf 3, onthoud 1",
          "Tientallen: 4 + 7 + 1 = 12 → schrijf 2, onthoud 1",
          "Honderdtallen: 8 + 9 + 1 = 18 → schrijf 8, onthoud 1",
          "Duizendtallen: 2 + 1 + 1 = 4",
          "Antwoord: 4.823 bezoekers"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-009",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "step_solver",
      "question": "Volg de stappen om 3.876 + 4.689 cijferend uit te rekenen. Werk van rechts naar links, en houd onthoud-cijfers bij.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "3.876 + 4.689 — vier-cijferige som met overdracht in elke kolom",
          "steps": [
            {
              "prompt": "Eenheden: 6 + 9 = ?",
              "correctAnswer": "15",
              "acceptedAnswers": ["15"],
              "hint": "6 + 9 = 15. Schrijf 5 onder de eenheden, onthoud 1 voor de tientallen."
            },
            {
              "prompt": "Tientallen: 7 + 8 + 1 (onthoud) = ?",
              "correctAnswer": "16",
              "acceptedAnswers": ["16"],
              "hint": "7 + 8 = 15, plus de 1 van eenheden = 16. Schrijf 6, onthoud 1."
            },
            {
              "prompt": "Honderdtallen: 8 + 6 + 1 (onthoud) = ?",
              "correctAnswer": "15",
              "acceptedAnswers": ["15"],
              "hint": "8 + 6 = 14, plus de 1 van tientallen = 15. Schrijf 5, onthoud 1."
            },
            {
              "prompt": "Duizendtallen: 3 + 4 + 1 (onthoud) = ?",
              "correctAnswer": "8",
              "acceptedAnswers": ["8"],
              "hint": "3 + 4 = 7, plus de 1 van honderdtallen = 8. Geen overdracht meer."
            },
            {
              "prompt": "Eindantwoord: zet de cijfers achter elkaar — wat is 3.876 + 4.689?",
              "correctAnswer": "8565",
              "acceptedAnswers": ["8565", "8.565"],
              "hint": "Duizendtallen 8, honderdtallen 5, tientallen 6, eenheden 5 → 8.565."
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [
        {
          "type": "column",
          "data": {
            "operand1": 3876,
            "operand2": 4689,
            "operation": "+"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — werk van rechts naar links met onthouden",
            "content": "Bij elke kolom tel je het onthoud-cijfer van de vorige kolom mee. Eenheden eerst, dan tientallen, dan honderdtallen, dan duizendtallen. Bij 3.876 + 4.689 krijg je in elke kolom een overdracht — dat is normaal. Schrijf netjes per kolom: 5, 6, 5, 8 → 8.565.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_step_solver_4cijferig",
      "variantIndex": 9,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.onthouden-vergeten", "label": "Vergeet onthoud-cijfer mee te tellen" },
          { "id": "rek.kolommen-verkeerd-uitgelijnd", "label": "Schrijft cijfers in verkeerde kolom" }
        ]
      },
      "feedback": {
        "explanationText": "3.876 + 4.689 = 8.565. Werk per kolom van rechts naar links en tel het onthoud-cijfer telkens op. Eenheden 6+9=15 (schrijf 5, onthoud 1). Tientallen 7+8+1=16 (schrijf 6, onthoud 1). Honderdtallen 8+6+1=15 (schrijf 5, onthoud 1). Duizendtallen 3+4+1=8. Antwoord: 8.565.",
        "solutionSteps": [
          "Eenheden: 6 + 9 = 15 → schrijf 5, onthoud 1",
          "Tientallen: 7 + 8 + 1 = 16 → schrijf 6, onthoud 1",
          "Honderdtallen: 8 + 6 + 1 = 15 → schrijf 5, onthoud 1",
          "Duizendtallen: 3 + 4 + 1 = 8",
          "Antwoord: 8.565"
        ]
      }
    }
  ]
}